import { defineMessages } from 'react-intl';

export default defineMessages({
  REMOVE_QUESTION: {
    defaultMessage: 'Voulez-vous vraiment supprimer la question :',
  },
});
